import index from './ChartPanel'
export default index